import { Controller } from '@hotwired/stimulus';
import { formatPriceForSelectedCurrency, getPricingForParticipants } from '../../bundles/utilities/pricing';

export default class extends Controller {
  static targets = [
    'displayPrice',
    'pricingDiv',
    'unsupportedDiv',
    'errorDiv',
  ];

  static values = {
    priceDetails: Object,
  };

  get participantCount() {
    const el = document.querySelector('[data-participant-count-filter]');
    if (el) {
      return Number.parseInt(el.dataset.participantCountFilter, 10);
    }

    return null;
  }

  connect() {
    if (!this.hasPricingDivTarget) {
      return;
    }
    this.hidePricing();
    this.updatePrices();
  }

  updatePrices() {
    if (!this.hasDisplayPriceTarget) {
      return;
    }
    const participants = this.participantCount;
    const priceDetails = getPricingForParticipants(this.priceDetailsValue, participants, true);

    if (priceDetails && priceDetails.valid) {
      let text;
      if (this.participantCount == null) {
        text = `From ${formatPriceForSelectedCurrency(priceDetails.displayPrice)} ${this.displayPriceTarget.dataset.displayText || ''}`;
      } else {
        text = formatPriceForSelectedCurrency(priceDetails.total);
      }
      this.displayPriceTarget.innerHTML = text;
      this.showPricing();
    } else if (priceDetails && !priceDetails.valid && this.participantCount != null) {
      if (priceDetails.minParticipants > participants) {
        this.errorDivTarget.innerHTML = `Needs at least ${priceDetails.minParticipants} people`;
        this.showError();
      } else if (priceDetails.maxParticipants < participants) {
        this.errorDivTarget.innerHTML = `Hosts up to ${priceDetails.maxParticipants} people`;
        this.errorDivTarget.classList.remove('hidden');
        this.showError();
      }
    } else {
      this.hidePricing();
    }
  }

  hidePricing() {
    this.pricingDivTarget.classList.add('hidden');
    this.unsupportedDivTarget.classList.remove('hidden');
  }

  showPricing() {
    this.pricingDivTarget.classList.remove('hidden');
    this.unsupportedDivTarget.classList.add('hidden');
    this.errorDivTarget.classList.add('hidden');
  }

  showError() {
    this.errorDivTarget.classList.remove('hidden');
    this.pricingDivTarget.classList.add('hidden');
    this.unsupportedDivTarget.classList.add('hidden');
  }
}
